// RELATED ITEMS SHOW / HIDE


// Reveal Below

jQuery(document).ready(function ($) {

  $(".reveal-below").click(function () {
    $(this).toggleClass('active');
    $(this).nextAll('.hidden').toggleClass('revealed');
    if ($(this).find('.state').text() === jsl10n["JavaScript.Reveal.Show"]) {
        $(this).find('.state').text(jsl10n["JavaScript.Reveal.Hide"]);
    } else {
        $(this).find('.state').text(jsl10n["JavaScript.Reveal.Show"]);
    }
  });

});

// Reveal Above

jQuery(document).ready(function ($) {
  
  $(".reveal-above").click(function () {
    $(this).toggleClass('active');
    $(this).prevAll('.hidden').toggleClass('revealed');
    if ($(this).find('.state').text() === jsl10n["JavaScript.Reveal.Show"]) {
        $(this).find('.state').text(jsl10n["JavaScript.Reveal.Hide"]);
    } else {
        $(this).find('.state').text(jsl10n["JavaScript.Reveal.Show"]);
    }
  });

});

// Product Detail

jQuery(document).ready(function ($) {
  
  $(".show-products").click(function () {
    $(this).toggleClass('active');
    $(this).next('.hidden-products').toggleClass('visible');
  });

});
